import React, { useState, useContext } from 'react';
import { useNavigate, useParams, useOutletContext } from 'react-router-dom';
import AuthContext from './AuthContext';
import LoadingSpinner from './LoadingSpinner';
import './LoginForm.css';

const LoginForm = () => {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const { dataClient } = useOutletContext();
  const { login, user } = useContext(AuthContext); // Access user from AuthContext

  const [formData, setFormData] = useState({
    login: '',
    password: '',
    customer_id: customerId,
    role_name: '',
    active: ''
  });

  if (!dataClient) {
    return <LoadingSpinner />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log('REACT_APP_PROXY_URL:', process.env.REACT_APP_PROXY_URL);
      const response = await fetch(`${process.env.REACT_APP_PROXY_URL}/api/customer/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const token = data.token; // Assume token is in the response
      console.log('JWT Token:', token);

      // Store token and update AuthContext
      login(token); // Login updates the user state

      // Retrieve role_name from localStorage
      const roleName = localStorage.getItem('role_name');
      const userId = localStorage.getItem('id');
      //console.log('Role Name from localStorage:', roleName);
   
      // Evaluate role_name 
      if (roleName === 'Admin' || roleName === 'SuperAdmin') {
        navigate(`/customer/${customerId}/client/list`);
        
      } else if (roleName === 'User') {
        navigate(`/customer/${customerId}/user/manage/${userId}`);
      } else {
        alert('Unauthorized role. Contact support.');
      }
    } catch (error) {
      console.error('Error during login:', error.message);
      alert('Login failed. Please check your credentials and try again.');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <table
        className="tableMain"
        border="0"
        width="100%"
        cellPadding="2"
        cellSpacing="2"
      >
        <tbody>
          <tr>
            <td className="lbltxt">User Name:</td>
            <td>
              <input
                className="fieldsSm"
                type="text"
                name="login"
                value={formData.login}
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <td className="lbltxt">Password:</td>
            <td>
              <input
                className="fieldsSm"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <input
                type="submit"
                name="LoginSubmit"
                value="login"
                id="login"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <input name="customer_id" type="hidden" value={formData.customer_id} />
    </form>
  );
};

export default LoginForm;